import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../react/components/Button';

const ResetSession = ({ handleCloseModal }: ResetSessionProps) => (
  <div className="c-cyop__modal-buttons">
    <Button
      cyopModal
      onClick={handleCloseModal}
      onKeyDown={handleCloseModal}
    >
      Reload
    </Button>
  </div>
);

const resetSessionPropTypes = {
  handleCloseModal: PropTypes.func.isRequired,
};

ResetSession.propTypes = resetSessionPropTypes;

type ResetSessionProps = PropTypes.InferProps<typeof resetSessionPropTypes>;

export default ResetSession;
